import moment from "moment";
import create, { StateCreator, StoreApi } from "zustand";

interface IDataQualityReportStore {
  clearStore: () => void;
  payer: any;
  setPayer: (x: any) => void;
  fileType: any;
  setFileType: (x: any) => void;
  selectedDateRange: any;
  setSelectedDateRange: (x: any) => void;
  selectedScoreType: any;
  setSelectedScoreType: (x: any) => void;
  dataDetails: any;
  setDataDetails:  (x: any) => void;
  scoreBoardValue: any;
  setScoreBoardValue:  (x: any) => void;
  loadingForCardOrTableView: any;
  setLoadingForCardOrTableView: (x: any) => void;
  scoreBoardLoading: any;
  setScoreBoardLoading: (x: any) => void;
  failedFilesType: any;
  setFailedFilesType:  (x: any) => void;
}

let store: StateCreator<IDataQualityReportStore, [], [], IDataQualityReportStore> | StoreApi<IDataQualityReportStore> = (set) => ({
  payer: [],
  setPayer: (x) => {
    set(() => ({ payer: x }));
  },
  fileType: [],
  setFileType: (x) => {
    set(() => ({ fileType: x }));
  },
  selectedDateRange: {startDate: moment().startOf('month').format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD")},
  setSelectedDateRange: (x) => {
    set(() => ({ selectedDateRange: x }));
  },
  selectedScoreType: null,
  setSelectedScoreType: (x) => {
    set(() => ({ selectedScoreType: x }));
  },
  dataDetails: [],
  setDataDetails: (x) => {
    set(() => ({ dataDetails: x }));
  },
  scoreBoardValue: true,
  setScoreBoardValue: (x) => {
    set(() => ({ scoreBoardValue: x }));
  },
  loadingForCardOrTableView: false,
  setLoadingForCardOrTableView: (x) => {
    set(() => ({ loadingForCardOrTableView: x }));
  },
  scoreBoardLoading: false,
  setScoreBoardLoading: (x) => {
    set(() => ({ scoreBoardLoading: x }));
  },
  failedFilesType: true,
  setFailedFilesType: (x) => {
    set(() => ({ failedFilesType: x }));
  },
  clearStore: () => {
    set(() => ({ payer: [] }));
    set(() => ({ fileType: [] }));
    set(() => ({ selectedDateRange: {startDate: moment().startOf('month').format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD")} }));
    set(() => ({ selectedScoreType: undefined }));
    set(() => ({ dataDetails: [] }));
    set(() => ({ scoreBoardValue: undefined }));
    set(() => ({ loadingForCardOrTableView: false }));
    set(() => ({ scoreBoardLoading: false }));
    set(() => ({ failedFilesType: false }));
  },
});

export const useDataQualityReportStore = create(store);
